export const toLogout = '/customer/account/logout'
